import { ChangeLogoModal } from './changeLogoModal';

export default ChangeLogoModal;
